var Errors = {
  ajaxErrorHandler : function ( evt ) {
    popup.generatePopup({
      method: 'static',
      content: evt.responseText,
      fullScreen: true,
    });
  },
};